"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monthWindows = monthWindows;
exports.revenueAndExpenses = revenueAndExpenses;
exports.overdueOf = overdueOf;
const money_1 = require("../money");
const financial_statements_1 = require("../ledger/financial-statements");
function pad(value) {
    return String(value).padStart(2, '0');
}
function lastDayOf(year, month) {
    // اليوم صفر من الشهر التالى هو آخر يوم فى هذا الشهر — بالتقويم لا بالمنطقة الزمنية
    return new Date(Date.UTC(year, month, 0)).getUTCDate();
}
/**
 * آخر `count` شهرًا حتى `asOf`، الأقدم أولاً. الشهر الأخير جزئى (من أوله حتى `asOf`)
 * حتى لا تُقارن اللوحة شهرًا كاملاً بأيام لم تأتِ بعد. التاريخ يُمرَّر — لا «اليوم» هنا.
 */
function monthWindows(asOf, count) {
    const year = Number(asOf.slice(0, 4));
    const month = Number(asOf.slice(5, 7));
    const windows = [];
    for (let back = count - 1; back >= 0; back -= 1) {
        const index = year * 12 + (month - 1) - back;
        const y = Math.floor(index / 12);
        const m = (index % 12) + 1;
        const key = y + '-' + pad(m);
        windows.push({
            month: key,
            from: key + '-01',
            to: back === 0 ? asOf : key + '-' + pad(lastDayOf(y, m)),
        });
    }
    return windows;
}
/**
 * إيراد ومصروف فترة من حركة حساباتها — عبر قائمة الدخل نفسها، فلا يمكن أن تختلف
 * أرقام اللوحة عن القائمة لنفس الفترة.
 */
function revenueAndExpenses(movements) {
    const statement = (0, financial_statements_1.incomeStatement)(movements);
    return {
        revenue: statement.revenue.total,
        expenses: statement.costOfSales.total.add(statement.expenses.total).normalize(),
        operatingProfit: statement.operatingProfit,
    };
}
/** صافى المتأخر من شرائح الأعمار: كل ما تجاوز استحقاقه، بلا خصم الدائن غير المخصص. */
function overdueOf(buckets) {
    return money_1.Money.sum([
        buckets.days1to30,
        buckets.days31to60,
        buckets.days61to90,
        buckets.over90,
    ]).normalize();
}
//# sourceMappingURL=dashboard.js.map